import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PUBLISH_CONFIGURATION, PUBLISH_CONFIGURATION_SUCCESS, PUBLISH_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* publishConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/benefit-type/airport-transfer/configuration/${payload?.id}/publish`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: PUBLISH_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: PUBLISH_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PUBLISH_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchpublishConfiguration() {
  yield takeEvery(PUBLISH_CONFIGURATION, publishConfiguration);
}

function* publishConfigurationSaga() {
  yield all([fork(watchpublishConfiguration)]);
}

export default publishConfigurationSaga;
